import { SectionLabel } from '@/components/marketing/v2/SectionLabel';

const PILLARS: ReadonlyArray<{
  num: string;
  title: string;
  desc: string;
  accent: 'lime' | 'terracotta' | 'charcoal';
}> = [
  {
    num: '01',
    title: 'Le réseau est un bonus, pas une condition',
    desc: "Tout ce qui est critique pour vendre (ticket, stock, paiement, impression) fonctionne localement. Le cloud synchronise quand il peut, jamais pendant l'acte de vente.",
    accent: 'lime',
  },
  {
    num: '02',
    title: 'Simple, pas simpliste',
    desc: 'Une caissière débutante doit vendre en 3 minutes après installation. Un gérant multi-sites doit avoir ses 12 KPIs consolidés en 1 écran. Les deux, dans le même outil.',
    accent: 'terracotta',
  },
  {
    num: '03',
    title: 'Les prix africains sont une contrainte, pas une excuse',
    desc: "333 F CFA par jour pour un commerce, ça reste une décision. On fait tenir notre P&L avec ça en visant la fiabilité, pas l'empilement de fonctionnalités.",
    accent: 'charcoal',
  },
];

const ACCENT: Record<(typeof PILLARS)[number]['accent'], string> = {
  lime: 'bg-lime-500 text-charcoal-800',
  terracotta: 'bg-terracotta-500 text-white',
  charcoal: 'bg-charcoal-800 text-lime-400',
};

export default function ApproachPillarsV2() {
  return (
    <section className="bg-white py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <SectionLabel className="justify-center">Notre approche</SectionLabel>
          <h2 className="mt-6 font-marketing-display text-[clamp(36px,5vw,64px)] font-bold leading-[1] tracking-[-0.035em] text-charcoal-800">
            Trois principes. <span className="underline-lime">Zéro compromis.</span>
          </h2>
          <p className="mt-6 font-marketing-body text-lg text-charcoal-600">
            Chaque décision produit passe par ces trois filtres. Ça nous évite de dériver vers les
            fausses bonnes idées à la mode.
          </p>
        </div>

        <div className="mt-16 grid gap-7 md:grid-cols-3">
          {PILLARS.map((p, idx) => (
            <article
              key={p.num}
              className={`flex flex-col border-2 border-charcoal-800 bg-white p-7 shadow-neobrutal-6 transition-transform hover:-translate-x-[2px] hover:-translate-y-[2px] hover:shadow-neobrutal-10 md:p-8 ${idx === 1 ? 'md:-translate-y-6' : ''}`}
            >
              <div
                className={`inline-flex h-14 w-14 items-center justify-center border-2 border-charcoal-800 font-marketing-display text-lg font-bold shadow-neobrutal-2 ${ACCENT[p.accent]}`}
              >
                {p.num}
              </div>
              <h3 className="mt-6 font-marketing-display text-[22px] font-bold leading-[1.2] tracking-[-0.02em] text-charcoal-800 md:text-[24px]">
                {p.title}
              </h3>
              <p className="mt-4 font-marketing-body text-[15.5px] leading-relaxed text-charcoal-600">
                {p.desc}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
